import { QueryFunctionContext } from 'react-query';
import { IHashtag } from '../../interfaces/feed.interface';
import { FolderStatusEnum } from '../../interfaces/training.interface';
import { tmsHTTPRequest } from '../../services/axios/httpRequest';

export const getAllHashtag = () => {
  return tmsHTTPRequest.get('/v1/hashtags') as unknown as IHashtag[];
};

export const getOnboardStatus = () => {
  return tmsHTTPRequest.get('/users/onboarding') as unknown as boolean;
};

export const putOnboardStatus = () => {
  return tmsHTTPRequest.put('/users/onboarding', {});
};

export const putUserHashtag = (hashtags: string[]) => {
  return tmsHTTPRequest.put('/users/tag', { hashtags });
};

export const getUserHashtag = () => {
  return tmsHTTPRequest.get('/users/tag') as unknown as IHashtag[];
};

export const getRecommendedGroupsOnboarding = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/folders/recommended?PageNumber=${pageParam}&PageSize=${
      queryKey[1] || 6
    }`
  );
};

export const getRecommendedGroupsHomeFeed = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/folders/home/recommend?PageNumber=${pageParam}&PageSize=${
      queryKey[1] || 8
    }`
  );
};

export const getRecommendedGroupsVisitorFeed = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/folders/feed/recommend?PageNumber=${pageParam}&PageSize=${
      queryKey[1] || 8
    }`
  );
};

export const getJoinedGroupsUserWall = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/folders/user/all?UserId=${
      queryKey[1]
    }&PageNumber=${pageParam}&PageSize=${queryKey[2] || 8}`
  );
};

export const postJoinGroup = (
  groupId: string,
  folderStatus: FolderStatusEnum = FolderStatusEnum.Public
) => {
  return tmsHTTPRequest.post(
    `/v1/folders/${groupId}/join?GroupType=${folderStatus}`,
    {}
  );
};

export const deleteCancelRequestJoinGroup = (folderId: string) => {
  return tmsHTTPRequest.delete(`/v1/folders/${folderId}/request`);
};
